module.exports = __webpack_public_path__ + "static/media/approved.f9aeb805.svg";